import Model, { attr } from '@ember-data/model';

export default class SavedReplyModel extends Model {
  @attr('string') name!: string;
  @attr('string') content!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'saved-reply': SavedReplyModel;
  }
}
